var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toolbar" },
    _vm._l(_vm.onlyVisibles(_vm.buttons), function (button, index) {
      return _c(
        "div",
        { key: button.label, staticClass: "inlinebutton" },
        [
          _c(
            "drop",
            {
              on: {
                drop: function ($event) {
                  var i = arguments.length,
                    argsArray = Array(i)
                  while (i--) argsArray[i] = arguments[i]
                  return _vm.handleDrop.apply(
                    void 0,
                    [button].concat(argsArray)
                  )
                },
                dragenter: function ($event) {
                  var i = arguments.length,
                    argsArray = Array(i)
                  while (i--) argsArray[i] = arguments[i]
                  return _vm.handleDragenter.apply(
                    void 0,
                    [button].concat(argsArray)
                  )
                },
                dragover: function ($event) {
                  var i = arguments.length,
                    argsArray = Array(i)
                  while (i--) argsArray[i] = arguments[i]
                  return _vm.handleDragover.apply(
                    void 0,
                    [button].concat(argsArray)
                  )
                },
                dragleave: function ($event) {
                  var i = arguments.length,
                    argsArray = Array(i)
                  while (i--) argsArray[i] = arguments[i]
                  return _vm.handleDragleave.apply(
                    void 0,
                    [button].concat(argsArray)
                  )
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dmdeskButtonContainer",
                  class: _vm.buttonContainerClass(button, index),
                },
                [
                  button.iconHead
                    ? _c(
                        "button",
                        {
                          staticClass: "dmdeskCategoryButtonClass",
                          class: _vm.buttonClass(button, index),
                        },
                        [
                          _c("span", { staticClass: "fa-stack fa-1x" }, [
                            _c("i", {
                              staticClass: "fa fa-circle fa-stack-2x",
                            }),
                            _c("i", {
                              staticClass: "fa fa-lg fa-stack-1x fa-inverse",
                              class: button.iconHead,
                            }),
                          ]),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "dmdeskButton",
                          class: _vm.buttonClass(button, index),
                          attrs: {
                            disabled: button.isButtonDisabled == true,
                            title: _vm.$t(button.label),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.buttonFunction(button)
                            },
                            mouseover: function ($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.onOverMainButton.apply(
                                void 0,
                                [button].concat(argsArray)
                              )
                            },
                          },
                        },
                        [
                          button.icon && button.iconstack
                            ? _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-stack-1x",
                                  class: [button.animate, button.icon],
                                }),
                                _c("i", {
                                  staticClass: "fa fa-stack-2x",
                                  class: button.iconstack,
                                }),
                              ])
                            : _vm._e(),
                          button.icon && !button.iconstack
                            ? _c("i", {
                                staticClass: "fa",
                                class: [button.animate, button.icon],
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(!button.icon ? _vm.$t(button.label) : "") +
                              "\n        "
                          ),
                        ]
                      ),
                  button.dropdown
                    ? _c(
                        "button",
                        {
                          staticClass: "dmdeskButtonExpand",
                          on: {
                            click: function ($event) {
                              button.isDrop = !button.isDrop
                            },
                            mouseover: function ($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.onOverExpandButton.apply(
                                void 0,
                                [button].concat(argsArray)
                              )
                            },
                            mouseleave: function ($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.onLeave.apply(
                                void 0,
                                [button].concat(argsArray)
                              )
                            },
                          },
                        },
                        [_c("span", { staticClass: "caret" })]
                      )
                    : _vm._e(),
                  button.dropdown
                    ? _c(
                        "ul",
                        {
                          staticClass: "dropdownbuttons",
                          class: { dropdownbuttonsvisible: button.isDrop },
                          style: _vm.styles,
                          on: {
                            mouseover: function ($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.onOverExpandButton.apply(
                                void 0,
                                [button].concat(argsArray)
                              )
                            },
                            mouseleave: function ($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.onLeave.apply(
                                void 0,
                                [button].concat(argsArray)
                              )
                            },
                          },
                        },
                        _vm._l(button.dropdown, function (dropbutton) {
                          return _c(
                            "li",
                            {
                              key: dropbutton.label,
                              staticClass: "inlinebutton",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "dmdeskButton dmdeskButtonindropdown",
                                  class: _vm.dropButtonClass(dropbutton),
                                  attrs: {
                                    title: _vm.$t(dropbutton.label),
                                    disabled:
                                      dropbutton.isButtonDisabled == true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.buttonFunction(dropbutton)
                                    },
                                  },
                                },
                                [
                                  dropbutton.icon && dropbutton.iconstack
                                    ? _c("span", { staticClass: "fa-stack" }, [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-stack-2x text-danger",
                                          class: dropbutton.iconstack,
                                        }),
                                        _c("i", {
                                          staticClass: "fa fa-stack-1x",
                                          class: dropbutton.icon,
                                        }),
                                      ])
                                    : _vm._e(),
                                  dropbutton.icon && !dropbutton.iconstack
                                    ? _c("i", {
                                        staticClass: "fa",
                                        class: dropbutton.icon,
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t(dropbutton.label)) +
                                      "\n              " +
                                      _vm._s(_vm.getShortcut(dropbutton)) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }